<template>
  <div>
    <edit-page-header
      page="NOTICE"
      :date="form.created"
    >
      <el-button
        class="light-gray"
        @click="handleClickCancel"
      >
        취소
      </el-button>
      <el-loading-button
        class="black"
        :is-loading="isSaveNotice"
        :disabled="!isFormValidated"
        @click="handleClickSave"
      >
        저장
      </el-loading-button>
    </edit-page-header>

    <div class="notice-form">
      <el-form
        :model="form"
        label-position="top"
        label-width="100px"
      >
        <el-form-item
          label="제목"
          prop="title"
        >
          <el-input
            v-model="form.title"
            placeholder="제목을 입력해주세요. (50자 이내)"
            :maxlength="50"
          />
        </el-form-item>
        <el-form-item
          label="내용"
          prop="contents"
        >
          <quill-editor
            class="editor"
            :options="editorOption"
            :content="form.contents"
            @change="onEditorChange($event)"
          />
        </el-form-item>

        <div class="upload-form">
          <ImageUploadField
            v-model="form.images"
            :initial-file-list="initialFileList"
            :usage="2"
          />
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { quillEditor, Quill } from 'vue-quill-editor';
import autoLinks from 'quill-auto-links';
import EditPageHeader from '@/components/EditPageHeader';
import ElLoadingButton from '@/components/el-loading-button';
import ImageUploadField from '@/components/ImageUploadField';
import { fiflboxApi } from '@/utils/api';
Quill.register('modules/autoLinks', autoLinks);

export default {
  name: 'NoticeEditForm',
  components: {
    ImageUploadField,
    ElLoadingButton,
    EditPageHeader,
    quillEditor,
  },
  props: ['data'],
  data() {
    return {
      editorOption: {
        placeholder: '',
        modules: {
          autoLinks: true,
          toolbar: [
            [
              { header: [
                1, 2, 3, 4, false,
              ] },
              'bold',
              'italic',
              'underline',
              { color: [] },
              { background: [] },
              { align: [] },
              { list: 'bullet' },
              'link',
            ],
          ],
        },
      },
      isSaveNotice: false,
      initialFileList: [],
      form: {
        created: null,
        title: '',
        contents: '',
        images: [],
      },
    };
  },
  computed: {
    uploadHeaders() {
      return {
        Authorization: this.$tokenStorage.getBearerToken(),
      };
    },
    isFormValidated() {
      return this.form.title.length > 0 && this.form.contents.length > 0;
    },
  },
  async created() {
    if (this.$route.name === 'main/notice/edit') {
      this.noticeId = this.$route.params.noticeId;
      await this.syncData();
    }
  },
  methods: {
    onEditorChange({ quill, html, text }) {
      this.form.contents = html;
    },
    async handleClickSave() {
      const errMsg = {
        title : '형식 오류',
        contents : '현재 사용 중인 폰트색상을 인식 할 수 없습니다.\n에디터의 폰트색상을 이용하세요.',
      };
      this.isSaveNotice = true;
      
      if (this.$route.name === 'main/notice/edit') {
        try {
          await fiflboxApi.v1.putCenterNotices(this.noticeId, this.form);
          this.$message('공지가 수정됐습니다.');
          return this.$router.replace(`/notices/${this.noticeId}`).catch(()=>{});
        } catch (err) {
          this.$alert(errMsg.contents,errMsg.title);
          this.isSaveNotice = false;
          return this.$message(err);
        }
      }

      try {
        await fiflboxApi.v1.postCenterNotices(this.form);
        this.$message('공지가 등록됐습니다.');
        this.$router.replace('/notices').catch(()=>{});
      } catch (err) {
        this.$alert(errMsg.contents,errMsg.title);
        this.isSaveNotice = false;
      }
    },
    async handleClickCancel() {
      if (this.$route.name === 'main/notice/edit') {
        return this.$router.replace(`/notices/${this.noticeId}`).catch(()=>{});
      }

      return this.$router.replace('/notices').catch(()=>{});
    },
    async syncData() {
      let { data: notice } = await fiflboxApi.v1.getCenterNoticeById(this.noticeId);
      this.form = notice;
      this.initialFileList = notice.images.map(image => {
        return {
          id: image.id,
          name: image.filename,
          url: image.image,
        };
      });
      this.form.images = notice.images.map(image => image.id);
    },
  },
};
</script>

<style lang="scss">
.notice-form {
	background-color: #ffffff;
	padding: 10px 25px;
	border-radius: 10px;

	.editor {
		height: 330px;
		margin-bottom: 34px;

    .ql-editor {
      -webkit-user-select: auto;
      -webkit-user-drag: auto;
    }
	}
}

.upload-form {
	width: 330px;
	margin: 0;

	@media screen and (max-width: 768px) {
		width: 100%;
		margin-top: 45px;
	}
}
</style>
